import React from 'react'
import styled from 'styled-components/native'
import Typography from 'APP/Converse/Typography'
import RadioButton from './RadioButton'

import { RadioGroupProps } from './types'

const RadioGroupContainer = styled.View`
  gap: ${({ theme }) => theme.metrics.baseMargin / 2}px;
`

const RadioButtonsContainer = styled.View<{ hasLabel: boolean }>`
  gap: ${({ theme }) => theme.metrics.baseMargin / 2}px;
  margin-left: ${({ theme, hasLabel }) => (hasLabel ? theme.metrics.baseMargin / 2 : 0)}px;
`

const RadioGroup = ({
  label,
  options = [],
  currentValue,
  onPress,
  buttonContainerStyle,
  testID = 'radio-group',
}: RadioGroupProps) => (
  <RadioGroupContainer style={buttonContainerStyle} testID={testID}>
    {!!label && <Typography variant="bodyNormalBold">{label}</Typography>}
    <RadioButtonsContainer hasLabel={!!label}>
      {options.map((option, i) => (
        <RadioButton
          key={option.value}
          status={currentValue === option.value ? 'checked' : 'unchecked'}
          onPress={onPress}
          label={option.label}
          value={option.value}
          testID={`${testID}-${i}`}
        />
      ))}
    </RadioButtonsContainer>
  </RadioGroupContainer>
)

export default RadioGroup
